module.exports = __webpack_public_path__ + "img/supermercado1.3630a9d5.jpg";